import { makeAutoObservable } from "mobx";
import { PCustomParameterInstanceId } from "./PCustomParameterInstanceId";
import { PProductError } from "./PProductError";
export class PCustomParameterInstance {
    constructor(params) {
        this.instanceId = new PCustomParameterInstanceId();
        this.domain = params.domain;
        this.customParameterType = params.customParameterType;
        this.touched = false;
        makeAutoObservable(this);
    }
    get isVisible() {
        return this.choices.length > 0;
    }
    get typeId() {
        return this.domain.typeId;
    }
    get name() {
        return this.customParameterType.name;
    }
    get availability() {
        return this.domain.availability;
    }
    // NOTICE: Custom parameter is always required
    get isRequired() {
        return true;
    }
    get error() {
        if (this.touched &&
            this.domain.availability.unavailabilityReasons.includes("Required")) {
            return PProductError.required();
        }
        return PProductError.none();
    }
    get choices() {
        return this.customParameterType.choices.objects.raw;
    }
    choiceAvailability(customParameterChoiceId) {
        return this.domain.choiceAvailability(customParameterChoiceId);
    }
    isSelected(customParameterChoiceId) {
        const { selectedChoice } = this.domain;
        return ((selectedChoice && selectedChoice.eq(customParameterChoiceId)) || false);
    }
    choose(customParameterChoiceId) {
        this.touch();
        this.domain.choose(customParameterChoiceId);
    }
    touch() {
        this.touched = true;
    }
}
